<template>
	<v-badge small color="orange" :value="canShowBadge">
		<template v-slot:badge>
			<span>
				<v-icon small>mdi-exclamation</v-icon>
			</span>
		</template>
		<v-icon>mdi-human-male-board</v-icon>
	</v-badge>
</template>

<script>
import presenterModeMixin from '../../../mixins/PresenterMode';

export default {
	inject: ['lessonPlanController'],
	mixins: [presenterModeMixin],
	computed: {
		hasSpeakerNotes() {
			const speakerNotes = this.lessonPlanController.navigation.selectedSlide.notes.speaker;
			const notesHasContent = speakerNotes !== '<p></p>' && speakerNotes !== '';

			return notesHasContent;
		},
		canShowBadge() {
			return this.hasSpeakerNotes;
		}
	}
};
</script>
